import React from "react";

export default function ToTop() {
  return (
    <div className="back-to-top cursor-pointer">
      <i className="bx bxs-up-arrow-alt"></i>
    </div>
  );
}
